<div class="container-fluid">
    <h3 id="main-area-header-label" class="row"> Search for Non-Criminal Cases</h3>
    <div class="row">
      <div id="civil-search-criteria-div" [ngClass]="{'col-xs-2': isSearchDivOpen, 'closed': !isSearchDivOpen}">
      <form #civilSearchForm [formGroup]="civilSearchFormGroup" autocomplete="off">
        <accordion [closeOthers]="true">
          <accordion-group [isOpen]="false" #caseNumberGroup>
            <div
              accordion-heading
              id="civil-search-criteria-overhead-search-by-case-number"
              tabindex="50"
              class="search-criteria-overhead"
              (click)="selectAccordion(enums.AccordionType.Case_Number, $event)">
              <i class="glyphicon pull-left"
                [ngClass]="{'glyphicon-triangle-bottom': caseNumberGroup?.isOpen, 'glyphicon-triangle-right': !caseNumberGroup?.isOpen}"></i>               
              Case Number
            </div>
            <div formGroupName="caseLookup">
              <div id="civil-county-select" 
                  [ngClass]="{'has-error':!civilSearchFormGroup.get('caseLookup.county').valid && submitted}">
                <label class="search-control-label"><span class="field-code">V474 </span>Case County</label>
                <select id="civil-county-select-control" tabindex="51" formControlName="county" class="form-control" formControlName="county">
                   <option *ngFor="let county of counties;" value="{{county.name}}">{{county.name}}</option>
                </select>
                <div class="control-label has-error"
                    *ngIf="submitted &&
                        civilSearchFormGroup.get('caseLookup.county').hasError('required')">
                    County is required.
                </div>
              </div>
              <div>&nbsp;</div>
              <div [ngClass]="{'has-error': (civilSearchFormGroup.get('caseLookup.caseNumber').errors)
                              && (submitted
                                  || civilSearchFormGroup.get('caseLookup.caseNumber').dirty
                                  || civilSearchFormGroup.get('caseLookup.caseNumber').touched)}">
                <label class="search-control-label"><span class="field-code">V475 </span>Case Number</label>
                <input id="civil-search-number-input"
                      tabindex="52"
                      name="casenumber"
                      type="text"
                      (keypress)="updateValidity($event, 'caseLookup.caseNumber', 'caseLookup');"
                      (blur) = "updateValidity($event, 'caseLookup.caseNumber', 'caseLookup');"
                      (focus) = "updateValidity($event, 'caseLookup.caseNumber','caseLookup');"
                      class="form-control input-sm"
                      formControlName="caseNumber"
                      appFocusable>
                <div class="control-label has-error"
                    *ngIf="(submitted 
                            || civilSearchFormGroup.get('caseLookup.caseNumber').dirty
                            || civilSearchFormGroup.get('caseLookup.caseNumber').touched)
                           && civilSearchFormGroup.get('caseLookup.caseNumber').hasError('required')">
                    Case Number is required.
                </div>
                <div class="control-label has-error"
                    *ngIf="(submitted 
                           || civilSearchFormGroup.get('caseLookup.caseNumber').dirty
                           || civilSearchFormGroup.get('caseLookup.caseNumber').touched)
                           &&
                           civilSearchFormGroup.get('caseLookup.caseNumber').hasError('pattern')">
                     Please enter a valid court case number. Example: 15CR123456.
                </div>
              </div>
            </div>
            <div>&nbsp;</div>
            <div align="center">
              <button id="civil-search-btn" tabindex="53" class="btn btn-primary" (click)="onSearch()"
                popover="Please correct the highlighted errors." triggers="" placement="right" #pop="bs-popover"
                (mouseenter)="(!civilSearchFormGroup.get('caseLookup.caseNumber').valid && submitted)? pop.show() : pop.hide();"
                (mouseleave)="pop.hide();"><i class="glyphicon glyphicon-search"></i> Search</button>
              <button id="civil-start-over-btn" tabindex="54" class="btn btn-primary" (click)="onStartOver()">Clear Form</button>
            </div>

          </accordion-group>
          <accordion-group [isOpen]="true" #partyNameSearchGroup>
            <div
              accordion-heading
              id="civil-search-criteria-overhead-search-by-other"
              tabindex="55"
              class="search-criteria-overhead"
              (click)="selectAccordion(enums.AccordionType.Party_Name, $event)">
              <i class="glyphicon pull-left"
                [ngClass]="{'glyphicon-triangle-bottom': partyNameSearchGroup?.isOpen, 'glyphicon-triangle-right': !partyNameSearchGroup?.isOpen}"></i>
              Party Name
            </div>
            <div formGroupName="nameSearch">
              <div>
                <label class="search-control-label"><span class="field-code">V476 </span>Case Counties</label>
                <div>
                  <ss-multiselect-dropdown
                    id="civil-multi-counties-select"
                    tabindex="57"
                    appSsMultiselectDropdownTabindexMigrator
                    [options]="counties"
                    [settings]="{enableSearch: true, dynamicTitleMaxItems: 1, showCheckAll: true, showUncheckAll: true, displayAllSelectedText: true, buttonClasses: 'btn btn-default btn-sm btn-multi-select',  containerClasses:'full-width'}"
                    [texts]="{checkAll: 'Select all', uncheckAll: 'Unselect all', checked: 'county selected', checkedPlural: 'counties selected', searchPlaceholder: 'Find', defaultTitle: 'ALL', allSelected: 'ALL'}"
                    formControlName="counties" appFocusable></ss-multiselect-dropdown>
                    <div id="civil-multi-counties-selections">
                      <span class="civil-multi-selections-label">Selected:</span> <span id="civil-multi-counties-selections-values" class="civil-multi-selections-values">{{ getSelectedNameSearchValues('counties') }}</span>
                    </div>
                </div>
              </div>
              <hr class="search-criteria-divider">
              <div>
                <input id="civil-search-business-name"
                       tabindex="190" 
                       type="checkbox" 
                       formControlName="searchBusinessNames"
                       appFocusable><span class="field-code">V477 </span>&nbsp;Search Business Names
              </div>
              <div class="btn-group pull-right">
                  <span dropdown id="civil-search-name-match-type-dropdown">
                      <a href dropdownToggle 
                         tabindex="191" 
                         (click)="false"
                         class="match-type-dropdown pull-right"><span class="field-code">V482 </span>{{civilSearchFormGroup.get('nameSearch.searchNameMatchType').value}}<i class="glyphicon glyphicon-triangle-bottom"></i></a>
                        <ul *dropdownMenu class="dropdown-menu">
                          <li *ngFor="let choice of searchModes; let i=index;">
                            <a id="{{'civil-search-name-match-type-' + choice}}" 
                               tabindex="{{195 + i}}" 
                               class="dropdown-item" 
                               (click)="selectMatchType(choice)">{{choice}}</a>
                          </li>
                        </ul>
                     </span>
                  <br>   
              </div>
              <div [class.search-item-hide]="!civilSearchFormGroup.get('nameSearch.searchBusinessNames').value">
               <div [ngClass]="{'has-error': !civilSearchFormGroup.get('nameSearch.businessName').valid
                                && ( submitted  
                                     || civilSearchFormGroup.get('nameSearch.businessName').touched
                                     || civilSearchFormGroup.get('nameSearch.businessName').dirty)}">
                 <br>
                 <label class="search-control-label"><span class="field-code">V484 </span>Business Name</label>
                 <input id="civil-business-name-input"
                       tabindex="210"
                       type="text"
                       class="form-control input-sm"
                       formControlName="businessName">                    
                 <div class="control-label has-error"
                     *ngIf="submitted && civilSearchFormGroup.get('nameSearch.businessName').hasError('required')">
                     Business Name is required.
                 </div>
               </div>
              </div>  
              <div [class.search-item-hide]="civilSearchFormGroup.get('nameSearch.searchBusinessNames').value">
                <br>
                <label class="search-control-label"><span class="field-code">V478.a </span>First Name</label>
                <input id="civil-first-name-input"
                      tabindex="210"
                      type="text"
                      class="form-control input-sm"
                      formControlName="firstName">
              </div>
              <div [class.search-item-hide]="civilSearchFormGroup.get('nameSearch.searchBusinessNames').value">
                <label class="search-control-label"><span class="field-code">V478.b </span>Middle Name</label>
                <input id="civil-middle-name-input"
                      tabindex="230"
                      type="text"
                      class="form-control input-sm"
                      formControlName="middleName">
              </div>
              <div [class.search-item-hide]="civilSearchFormGroup.get('nameSearch.searchBusinessNames').value">
                <div [ngClass]="{'has-error': submitted && !civilSearchFormGroup.get('nameSearch.lastName').valid}">
                  <label class="search-control-label"><span class="field-code">V478.c </span>Last Name</label>
                  <input id="civil-last-name-input"
                      tabindex="250"
                      type="text"
                      class="form-control input-sm"
                      formControlName="lastName"
                      appFocusable>
                  <div class="control-label has-error"
                      *ngIf="submitted && civilSearchFormGroup.get('nameSearch.lastName').hasError('required')">
                      Last Name is required.
                  </div>
                </div>
              </div>
              <hr class="search-criteria-divider">
              <div [class.search-item-hide]="false">
                <input id="civil-search-advanced-date-filter"
                       tabindex="251" 
                       type="checkbox" 
                       formControlName="advancedDateFilter"
                       appFocusable><span class="field-code">V520 </span>&nbsp;Advanced Date Filter
              </div>
              <div [class.search-item-hide]="!civilSearchFormGroup.get('nameSearch.advancedDateFilter').value">
                <div [ngClass]="{'has-error': civilSearchFormGroup.get('nameSearch.partyEnteredDate').invalid
                                              && (submitted
                                              || civilSearchFormGroup.get('nameSearch.partyEnteredDate').touched 
                                              || civilSearchFormGroup.get('nameSearch.partyEnteredDate').dirty) }">
                  <label class="search-control-label"><span class="field-code">V521 </span>Party, Alias, or Judgment Entered in System Since</label>
                  <input id="civil-search-party-entered-date" 
                         type="text" tabindex="252" 
                         class="form-control input-sm civil-search-party-entered-date-input inline-display" 
                        #dpMDY="bsDatepicker"
                        bsDatepicker
                        formControlName="partyEnteredDate"
                        placement="right"
                        [minDate]="minPartyEnteredDate"
                        [maxDate]="maxPartyEnteredDate"
                        [bsConfig]="{ containerClass: 'theme-default', dateInputFormat: 'MM/DD/YYYY'}"
                        appFocusable> 
                       <button id="civil-search-date-enterted-today-btn"  tabindex="253" class="btn btn-primary inline-display" (click)="setToday()">Today</button> 
                </div>
                <div [ngClass]="{'has-error': civilSearchFormGroup.get('nameSearch.partyEnteredDate').invalid
                                               && ( submitted 
                                               || civilSearchFormGroup.get('nameSearch.partyEnteredDate').touched 
                                               || civilSearchFormGroup.get('nameSearch.partyEnteredDate').dirty) }">
                  <div class="control-label has-error"
                       *ngIf="civilSearchFormGroup.get('nameSearch.partyEnteredDate').invalid
                              && ( submitted 
                              || civilSearchFormGroup.get('nameSearch.partyEnteredDate').touched 
                              || civilSearchFormGroup.get('nameSearch.partyEnteredDate').dirty)">
                          The entered date must be a valid date in the MM/DD/YYYY format; The entered date must be on or before the current date.
                  </div>
                </div>
              </div>
              <div [class.search-item-hide]="civilSearchFormGroup.get('nameSearch.advancedDateFilter').value">
                <label class="search-control-label">Case Years</label>
                <div class="column-count-2 text-align-left">
                  <div class="column-count-1" 
                       [ngClass]="{'has-error': (submitted 
                                  || civilSearchFormGroup.get('nameSearch.fromYear').touched 
                                  || civilSearchFormGroup.get('nameSearch.fromYear').dirty) 
                                  && ( civilSearchFormGroup.get('nameSearch.fromYear').invalid
                                    || civilSearchFormGroup.get('nameSearch').hasError('fromGreater'))}">
                    <label class="search-control-label"><span class="field-code">V479.a </span>From</label>
                    <input id="civil-search-years-from" type="number" 
                           tabindex="255" maxlengh="4" size="4" 
                           formControlName="fromYear" 
                           (keypress)="updateValidity($event, 'nameSearch.fromYear', 'nameSearch');"
                           (blur)="updateValidity($event, 'nameSearch.fromYear', 'nameSearch');"
                           (focus)="updateValidity($event, 'nameSearch.fromYear', 'nameSearch');"
                           class="form-control civil-search-year-input input-sm" 
                           [min]="minYear" [max]="maxYear" appFocusable/>
                  </div>
                  <div class="column-count-1" 
                       [ngClass]="{'has-error': (submitted
                                   || civilSearchFormGroup.get('nameSearch.toYear').touched
                                   || civilSearchFormGroup.get('nameSearch.toYear').dirty)
                                   && ( civilSearchFormGroup.get('nameSearch.toYear').errors
                                    || civilSearchFormGroup.get('nameSearch').hasError('fromGreater'))}">
                    <label class="search-control-label"><span class="field-code">V479.b </span>Through</label>
                    <input id="civil-search-years-to" type="number" 
                          tabindex="260" maxlength="4" size="4" 
                          formControlName="toYear" 
                          (keypress)="updateValidity($event, 'nameSearch.toYear', 'nameSearch');"
                          (blur)="updateValidity($event, 'nameSearch.toYear', 'nameSearch');"
                          (focus)="updateValidity($event, 'nameSearch.toYear', 'nameSearch');"
                          class="form-control civil-search-year-input input-sm" 
                          [min]="minYear" [max]="maxYear" appFocusable/>
                  </div>
                </div>
                <div [ngClass]="{'has-error': (submitted 
                                              || civilSearchFormGroup.get('nameSearch.fromYear').touched 
                                              || civilSearchFormGroup.get('nameSearch.fromYear').dirty
                                              || civilSearchFormGroup.get('nameSearch.toYear').touched
                                              || civilSearchFormGroup.get('nameSearch.toYear').dirty)  
                          && ( civilSearchFormGroup.get('nameSearch.fromYear').errors
                            || civilSearchFormGroup.get('nameSearch.toYear').errors
                            || civilSearchFormGroup.get('nameSearch').hasError('fromGreater'))}">
                  <div class="control-label has-error"
                       *ngIf="(submitted
                              || civilSearchFormGroup.get('nameSearch.fromYear').touched 
                              || civilSearchFormGroup.get('nameSearch.fromYear').dirty
                              || civilSearchFormGroup.get('nameSearch.toYear').touched
                              || civilSearchFormGroup.get('nameSearch.toYear').dirty )  
                              && (civilSearchFormGroup.get('nameSearch.fromYear').hasError('pattern')
                               || civilSearchFormGroup.get('nameSearch.fromYear').hasError('min')
                               || civilSearchFormGroup.get('nameSearch.fromYear').hasError('max')
                               || civilSearchFormGroup.get('nameSearch.toYear').hasError('pattern')
                               || civilSearchFormGroup.get('nameSearch.toYear').hasError('min')
                               || civilSearchFormGroup.get('nameSearch.toYear').hasError('max')
                               || civilSearchFormGroup.get('nameSearch').hasError('fromGreater'))">
                         Please enter a valid date range between 1966 and today.
                  </div>
                </div>  
              </div>
              <hr class="search-criteria-divider">
              <div>
                <label class="search-control-label"><span class="field-code">V480 </span>Case Types</label>
                <div>
                  <ss-multiselect-dropdown
                    id="civil-multi-case-types-select"
                    tabindex="270"
                    appSsMultiselectDropdownTabindexMigrator
                    [options]="caseTypes"
                    [settings]="{enableSearch: true, dynamicTitleMaxItems: 1, showCheckAll: true, showUncheckAll: true, displayAllSelectedText: true, buttonClasses: 'btn btn-default btn-sm btn-multi-select', containerClasses:'full-width'}"
                    [texts]="{checkAll: 'Select all', uncheckAll: 'Unselect all', checked: 'item selected', checkedPlural: 'items selected', searchPlaceholder: 'Find', defaultTitle: 'ALL', allSelected: 'ALL'}"
                    formControlName="caseTypes" appFocusable></ss-multiselect-dropdown>
                    <div id="civil-multi-case-types-selections">
                      <span class="civil-multi-selections-label">Selected:</span> 
                      <span id="civil-multi-case-types-selections-values" 
                      class="civil-multi-selections-values"
                      *ngIf="(!getSelectedNameSearchValueArray('caseTypes'))">ALL</span>
                      <div  class="civil-multi-selections-values-list" *ngFor="let typeVal of getSelectedNameSearchValueArray('caseTypes')">
                          <span class="civil-multi-selections-values-list-item">{{typeVal}}</span>
                      </div> 
                    </div>
                </div>
              </div>
              <hr class="search-criteria-divider">
              <div>
                <label class="search-control-label"><span class="field-code">V481 </span>Issue Types</label>
                <div>
                  <ss-multiselect-dropdown
                    id="civil-multi-issue-types-select"
                    tabindex="280"
                    appSsMultiselectDropdownTabindexMigrator
                    [options]="issueTypes"
                    [settings]="{enableSearch: true, dynamicTitleMaxItems: 1, showCheckAll: true, showUncheckAll: true, displayAllSelectedText: true, buttonClasses: 'btn btn-default btn-sm btn-multi-select',  containerClasses:'full-width'}"
                    [texts]="{checkAll: 'Select all', uncheckAll: 'Unselect all', checked: 'item selected', checkedPlural: 'items selected', searchPlaceholder: 'Find', defaultTitle: 'ALL', allSelected: 'ALL'}"
                    formControlName="issueTypes" appFocusable></ss-multiselect-dropdown>
                    <div id="civil-multi-issue-types-selections">
                      <span class="civil-multi-selections-label">Selected:</span> 
                      <span id="civil-multi-issue-types-selections-values" 
                            class="civil-multi-selections-values"
                            *ngIf="(!getSelectedNameSearchValueArray('issueTypes'))">ALL</span>
                      <div  class="civil-multi-selections-values-list" *ngFor="let typeVal of getSelectedNameSearchValueArray('issueTypes')">
                          <span class="civil-multi-selections-values-list-item">{{typeVal}}</span>
                      </div>                        
                    </div>
                </div>
              </div>
            </div>
            <div align="center"> 
              <button id="civil-search-btn" tabindex="400" class="btn btn-primary" (click)="onSearch()"
                popover="Please correct the highlighted errors." triggers="" placement="right" #partypop="bs-popover"
                (mouseenter)="(!civilSearchFormGroup.get('nameSearch').valid && submitted)? partypop.show() : partypop.hide();"
                (mouseleave)="partypop.hide();"><i class="glyphicon glyphicon-search"></i> Search</button>        
              <button id="civil-start-over-btn"  tabindex="401" class="btn btn-primary" (click)="onStartOver()">Clear Form</button>
            </div>            
          </accordion-group>
          <div>
              <span>All information displayed on this site is subject to the disclaimer posted 
              <a id="civil-disclaimer-view-lnk" tabindex="490" (click)="openDisclaimer();">here</a>.</span>
          </div>
        </accordion>
        <div *ngIf="!isProd()" class="show-field-code" [title]="showFieldCodeFlag ? 'Click to hide field code' : 'Click to show field code'" (click)="toggleFieldCodes()">    </div>
      </form>
    </div>     
    <div  id="civil-search-results-div" [ngClass]="{'col-xs-10': isSearchDivOpen, 'col-xs-12': !isSearchDivOpen}">
     <div id="civil-search-controls-outer-div"  
          *ngIf="(getIdentitySearchCases() || getIdentitySearchIndexedCases()) && !isCaseNumberAccordionOpen()" (click)="toggleSearchCriteria()" 
          [title]="isSearchDivOpen ? 'Close Search Criteria' : 'Open Search Criteria'">
        <div id="civil-search-controls-inner-div">
            <i id="civil-search-controls-arrow" class="fa fa-2x" [ngClass]="{'fa-chevron-circle-left': isSearchDivOpen, 'fa-chevron-circle-right': !isSearchDivOpen}" aria-hidden="true"></i>
          </div>
     </div>
     <div class="relative-position">
      <div *ngIf="searchCriteriaDescription" class="search-criteria-description-display">
        <span class="search-criteria-overhead-prefix">Search Results</span>
        <span>{{getTotalRecordsDescription()}} for</span>
        <span class="search-criteria-overhead-description"> {{searchCriteriaDescription}} </span>
        <br>
        <span class="search-record-last-updated-info">Note: The searched data was last updated from the system of record on {{searchRecordLastUpdateDate$ | async | date:'MM/dd/yyyy'}} at {{searchRecordLastUpdateDate$ | async | date:'shortTime'}}.</span>
      </div>
      <app-civil-search-results-table
        *ngIf="lastSubmittedSearchType === enums.SearchType.Case_Lookup"
        [cases]="caseLookupResults"
        [errors]="errors"
        [requestIsInFlight]="isRequestInFlight()"></app-civil-search-results-table>

      <div *ngIf="lastSubmittedSearchType === enums.SearchType.Party_Name_Cases || lastSubmittedSearchType === enums.SearchType.Party_Name_Indexed_Judgments">
        <tabset>
          <tab id="case-party-tab" (select)="tabSelected(enums.PartyNameSearchResultTab.Cases)" [active]="(activeSearchResultTab === enums.PartyNameSearchResultTab.Cases)">
            <ng-template tabHeading><span id="case-party-tab-heading">Cases</span></ng-template>  
            <app-civil-identity-search-results-table
              *ngIf="activeSearchResultTab === enums.PartyNameSearchResultTab.Cases"
              [cases]="getIdentitySearchCases()"
              [errors]="errors"
              [requestIsInFlight]="isRequestInFlight()"></app-civil-identity-search-results-table>
              <div *ngIf="doesIdentitySearchCasesHaveMoreRecords()">{{getDisplayedRecordsDescription()}}<a (click)="getNextIdentitySearchCases()" tabindex="8000" >Get more results?</a></div>
          </tab>
          <tab id="judgment-index-tab" (select)="tabSelected(enums.PartyNameSearchResultTab.Indexed_Judgments)" [active]="(activeSearchResultTab === enums.PartyNameSearchResultTab.Indexed_Judgments)">
            <ng-template tabHeading><span id="judgment-index-tab-heading">Indexed Judgments</span></ng-template>  
            <!--<template tabHeading>Indexed Judgments</template>
            <div *ngFor="let case of judgmentSearchResults">{{case.partyName.firstName}}, {{case.partyName.lastName}} | {{case.caseNumber.county}} {{case.caseNumber.fileNumber}}</div>
            -->
            <app-civil-index-search-results-table
              *ngIf="activeSearchResultTab === enums.PartyNameSearchResultTab.Indexed_Judgments"
              [cases]="getIdentitySearchIndexedCases()"
              [errors]="errors"
              [requestIsInFlight]="isRequestInFlight()"></app-civil-index-search-results-table>
              <div *ngIf="doesIdentitySearchIndexedCasesHaveMoreRecords()">{{getDisplayedRecordsDescription()}}<a (click)="getNextIdentitySearchIndexedCases()" tabindex="8001">Get more results?</a></div>
          </tab>
        </tabset>
      </div>
     </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/civil/civil.component.html